
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/globalpharma-emilok20",
      function () {
        return require("private-next-pages/[lang]/globalpharma-emilok20/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/globalpharma-emilok20"])
      });
    }
  